import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ServiceordreDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceordre-dto';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmCreateDialogData } from './confirm-create-dialog-data';

@Component({
    selector: 'app-confirm-create-dialog',
    templateUrl: './confirm-create-dialog.component.html',
    styleUrls: ['./confirm-create-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmCreateDialogComponent implements OnInit {
  serviceordre: ServiceordreDto;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmCreateDialogData) {
    this.serviceordre = data.serviceordre;
  }

  ngOnInit(): void {}
}
